import { type FacePhotoSize, facePhotoSizeSchema } from '@repo/api-contracts';

/** 원본 File을 브라우저가 표시하는 방향으로 디코딩한다. URL 소유권은 이 함수에만 있다. */
export const readPhotoSize = async (file: File, signal: AbortSignal): Promise<FacePhotoSize> => {
  signal.throwIfAborted();
  const url = URL.createObjectURL(file);
  const image = new Image();
  try {
    return await new Promise<FacePhotoSize>((resolve, reject) => {
      const cleanup = (): void => {
        signal.removeEventListener('abort', abort);
        image.onload = null;
        image.onerror = null;
      };
      const abort = (): void => {
        cleanup();
        image.src = '';
        reject(new DOMException('취소됨', 'AbortError'));
      };
      signal.addEventListener('abort', abort, { once: true });
      image.onload = () => {
        cleanup();
        const size = facePhotoSizeSchema.safeParse({
          widthPx: image.naturalWidth,
          heightPx: image.naturalHeight,
        });
        if (size.success) resolve(size.data);
        else reject(new Error('이미지의 가로·세로 크기는 1~20,000px이어야 합니다.'));
      };
      image.onerror = () => {
        cleanup();
        reject(new Error('이미지를 읽을 수 없습니다. 다른 파일을 선택해 주세요.'));
      };
      image.src = url;
    });
  } finally {
    URL.revokeObjectURL(url);
  }
};
